import {
  deleteContractDocumentType,
  clearContractDocumentTypeAction,
} from 'actions/contracts/contractDocumentTypeActions'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const ContractDocumentTypeDelete = ({ formId, closeModal, selected }) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearContractDocumentTypeAction())
    }
  }, [dispatch])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()
        dispatch(deleteContractDocumentType(selected))
        closeModal()
      }}
      className="form container"
    >
      <div>
        Are you sure you want to delete this contract document type? This can
        not be undone.
      </div>
    </form>
  )
}

export default ContractDocumentTypeDelete
